module.exports = __webpack_public_path__ + "img/outside_render_sm.bec1a9c5.jpg";